import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../app/hooks';
import { updateStep } from '../../../state';
import { useOfferedStepTypes } from '../../../hooks/useOfferedStepTypes';
import { WorkflowStepType, STEP_TYPE_LABELS, configurationForStepType } from '../../../../../services/WorkflowService';

interface StepTypeSelectProps {
  index: number;
}

// Only moves to or from HST provisioning reset the settings, so switching between the existing
// step types behaves as before.
const updatesForTypeChange = (from: WorkflowStepType, to: WorkflowStepType) => {
  const involvesHst = from === WorkflowStepType.HstProvisioningStep || to === WorkflowStepType.HstProvisioningStep;
  return involvesHst ? { stepType: to, configuration: configurationForStepType(to) } : { stepType: to };
};

export const StepTypeSelect: React.FC<StepTypeSelectProps> = ({ index }) => {
  const dispatch = useAppDispatch();
  const step = useAppSelector((state) => state.workflow.currentWorkflow?.steps[index]);
  const offeredTypes = useOfferedStepTypes();

  if (!step) return null;

  // A step already in the workflow keeps its type visible even when the flag is off.
  const options = offeredTypes.includes(step.stepType) ? offeredTypes : [...offeredTypes, step.stepType];

  return (
    <FormControl size="small" sx={{ minWidth: 200 }}>
      <InputLabel>Step Type</InputLabel>
      <Select
        value={step.stepType}
        label="Step Type"
        onChange={(e) => dispatch(updateStep({ index, updates: updatesForTypeChange(step.stepType, e.target.value as WorkflowStepType) }))}
      >
        {options.map((type) => (
          <MenuItem key={type} value={type}>{STEP_TYPE_LABELS[type]}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StepTypeSelect;
